import { useFind } from 'src/api/APIHooks';
import { groupBy, map } from 'lodash';

const useInvoiceInsuranceMemberIdOptions = (
  insuranceMemberIdLike,
  invoiceFilters,
) => {
  const { data } = useFind(
    'invoices',
    {
      ...invoiceFilters,
      insurance_external_member_id_like: insuranceMemberIdLike,
    },
    {
      queryConfig: {
        enabled: !!insuranceMemberIdLike,
        placeholderData: undefined,
      },
    },
  );

  const invoices = groupBy(
    data?.data?.data ?? [],
    'insurance_external_member_id',
  );
  const invoiceInsuranceMemberIdOptions = map(invoices, (_, key) => ({
    label: key,
    value: key,
  }));

  return invoiceInsuranceMemberIdOptions.slice(0, 30);
};

export default useInvoiceInsuranceMemberIdOptions;
